import React from 'react'
import Layout from '../components/layout/Layout'
import Seo from '../components/Seo'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const Terms: React.FC = () => {
  const updatedAt = '2026-02-09'
  return (
    <Layout>
      <Seo title="Regulamin — 2domy.pl" canonical="https://2domy.pl/terms" robots="index,follow" />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center text-slate-700 hover:text-slate-900">
            <ArrowLeft className="h-4 w-4 mr-2" /> Powrót do strony głównej
          </Link>
        </div>
        <div className="card-glass p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2 bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent">
            Regulamin serwisu 2domy.pl
          </h1>
          <p className="text-sm text-slate-500 mb-8">Ostatnia aktualizacja: {updatedAt}</p>

          <div className="prose prose-slate max-w-none">
            <h2>1. Postanowienia ogólne</h2>
            <p>
              Administratorem Serwisu 2domy.pl jest AITRAIN Marcin Opinc, NIP 5831541445, (brak KRS),
              adres korespondencyjny: ul. Kaszubska 6/21, 83-110 Tczew, e‑mail: kontakt@2domy.pl.
              Niniejszy regulamin określa zasady korzystania z Aplikacji oraz usług odpłatnych i nieodpłatnych.
              Akceptacja Regulaminu jest warunkiem korzystania z Serwisu.
            </p>

            <h2>2. Definicje</h2>
            <ul>
              <li>„Aplikacja” / „Serwis” – 2domy.pl.</li>
              <li>„Użytkownik” – osoba posiadająca konto.</li>
              <li>„Rodzina” – przestrzeń współdzielona Użytkowników (rodzice, obserwatorzy).</li>
              <li>„Administrator Rodzinny” – Użytkownik zakładający rodzinę i zarządzający uprawnieniami.</li>
              <li>„Dane Rodzinne” – wpisy kalendarza, dzieci, pliki, notatki, role i uprawnienia.</li>
              <li>„Plan Free” / „Plan Płatny” – warianty abonamentowe Aplikacji.</li>
            </ul>

            <h2>3. Konto, wiek, odpowiedzialność</h2>
            <ul>
              <li>Konto mogą zakładać osoby pełnoletnie.</li>
              <li>Administrator Rodzinny oświadcza, że posiada prawo do przetwarzania Danych Rodzinnych (w tym danych dzieci) i udzielania dostępu zaproszonym osobom.</li>
              <li>Użytkownik odpowiada za prawdziwość danych i bezpieczeństwo dostępu do konta/urządzenia.</li>
            </ul>

            <h2>4. Zakres i charakter usług</h2>
            <p>Aplikacja dostarcza narzędzia organizacyjne (kalendarz, udostępnianie, eksporty) i nie świadczy usług prawnych, mediacyjnych ani doradczych. Nie zastępuje ugody/porozumień ani orzeczeń.</p>

            <h2>5. Plany i limity</h2>
            <p>
              Szczegółowa specyfikacja dostępnych planów oraz limitów znajduje się w <strong>Załączniku A – Specyfikacja planów</strong> poniżej.
              Poniższe postanowienia mają charakter ogólny.
            </p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Plan Basic jest dostępny dla każdego zarejestrowanego użytkownika.</li>
              <li>Udostępnione funkcje oraz limity zależą od wybranego planu.</li>
              <li>Zmiana planu może skutkować egzekwowaniem limitów (np. liczba dzieci, historia).</li>
              <li>Serwis może stosować limity techniczne (rate‑limit, rozmiary plików, anty‑scraping).</li>
            </ul>

            <h2>6. Płatności i rozliczenia</h2>
            <p>
              Płatności realizowane są elektronicznie. Całkowita cena wraz z podatkami
              oraz ewentualnymi opłatami dodatkowymi jest prezentowana przed złożeniem zamówienia/rozpoczęciem subskrypcji
              na stronie <a href="/pricing">Cennik</a> oraz w interfejsie płatności. Subskrypcja odnawia się automatycznie do czasu anulowania przez Użytkownika.
            </p>
            <ul>
              <li>Usługa 2domy.pl jest przeznaczona wyłącznie dla konsumentów. Nie prowadzimy sprzedaży B2B i nie wystawiamy faktur VAT na firmy.</li>
              <li>Po każdej płatności Użytkownik otrzymuje elektroniczne potwierdzenie (receipt) od operatora płatności Stripe na adres e‑mail przypisany do konta. Faktury wysyłane są na żądanie – w tym celu należy skontaktować się przez <a href="/contact">formularz kontaktowy</a>.</li>
              <li>Brak płatności lub anulowanie powoduje powrót do planu Free i egzekwowanie limitów – bez usuwania danych.</li>
              <li>Moment zawarcia umowy: z chwilą potwierdzenia płatności przez operatora, a dostęp do funkcji planu płatnego aktywowany jest niezwłocznie po autoryzacji.</li>
            </ul>

            <h2>7. Zmiana planu i egzekwowanie limitów</h2>
            <ul>
              <li>Zmiana na plan Basic przy przekroczonych limitach: aktywne pozostaje 1 dziecko wskazane przez Administratora Rodzinnego (w braku wskazania – pierwsze dziecko).</li>
              <li>Obserwatorzy są zawieszeni (dostęp wstrzymany) do czasu ponownej aktywacji planu Płatnego.</li>
              <li>Historia może być ukryta w UI; eksport RODO pozostaje dostępny dla Administratora Rodzinnego.</li>
            </ul>

            <h2>8. Treści użytkownika i odpowiedzialność</h2>
            <p>Użytkownik zachowuje prawa do Treści i udziela Serwisowi niewyłącznej licencji na ich przetwarzanie wyłącznie w celu świadczenia usług (hostowanie, backup, generowanie eksportów). Zakazane jest umieszczanie treści bezprawnych, naruszających prawa dziecka lub danych wrażliwych bez podstawy prawnej. Niedozwolone jest także publikowanie treści wulgarnych, obraźliwych, nawołujących do nienawiści, dyskryminujących lub naruszających dobra osobiste innych osób (wpisów, notatek, zdarzeń itp.).</p>

            <h2>9. Prywatność i role RODO</h2>
            <p>Polityka prywatności stanowi integralną część Regulaminu.</p>
            <ul>
              <li>W zakresie danych kont (logowanie, rozliczenia) Serwis jest administratorem.</li>
              <li>W zakresie Danych Rodzinnych Serwis działa co do zasady jako podmiot przetwarzający na rzecz Administratora Rodzinnego. Na żądanie udostępniamy umowę powierzenia (DPA).</li>
              <li>Serwis korzysta z podprocesorów – wykaz w Załączniku B. Dane produkcyjne przechowywane są w UE (region eu‑central‑1).</li>
              <li>Użytkownik przyjmuje do wiadomości, że Dane Rodzinne mają charakter współdzielony. Administrator Rodzinny posiada uprawnienie do zarządzania składem Rodziny, co obejmuje prawo do usunięcia dowolnego Użytkownika z Rodziny w każdym czasie. Usunięcie Użytkownika z Rodziny skutkuje natychmiastową utratą jego dostępu do Danych Rodzinnych, przy czym wpisy dokonane przez tego Użytkownika w ramach Rodziny (np. w kalendarzu) pozostają częścią Danych Rodzinnych i nie są automatycznie usuwane, chyba że Administrator Rodzinny zdecyduje inaczej.</li>
            </ul>
            <p>
              Polityka prywatności:{' '}
              <a href="/polityka-prywatnosci" className="text-blue-600 hover:underline">przeczytaj na naszej stronie</a>
            </p>

            <h2>10. Bezpieczeństwo, szyfrowanie i ograniczenia</h2>
            <ul>
              <li>Dane przesyłane są z użyciem TLS; dane w spoczynku szyfrowane po stronie dostawcy infrastruktury.</li>
              <li>Aplikacja może oferować funkcje E2EE dla wybranych danych; zarządzanie kluczami po stronie Użytkownika. Utrata hasła/klucza może uniemożliwić odzyskanie części danych.</li>
              <li>PWA/Service Worker może buforować pliki na urządzeniu Użytkownika; zalecamy wylogowanie na urządzeniach współdzielonych.</li>
            </ul>

            <h2>11. Dostępność, utrzymanie i zmiany</h2>
            <p>Serwis świadczony jest w modelu „as is/as available” bez gwarancji nieprzerwanego działania. Możliwe przerwy techniczne, aktualizacje i zmiany funkcjonalne (w tym limity) – z informowaniem w miarę możliwości.</p>

            <h2>12. Dozwolony sposób korzystania</h2>
            <p>Zakaz: reverse engineering, automatyczne scrapowanie, obchodzenie limitów, udostępnianie dostępu osobom nieuprawnionym, działania naruszające bezpieczeństwo.</p>

            <h2>13. Własność intelektualna</h2>
            <p>UI, kod, logotypy i materiały Serwisu są chronione. Udzielamy niewyłącznej licencji na korzystanie z Aplikacji zgodnie z Regulaminem.</p>

            <h2>14. Zgłoszenia naruszeń i nadużyć</h2>
            <p>Zgłoszenia: kontakt@2domy.pl. Możemy czasowo zablokować dostęp do spornych treści do czasu wyjaśnienia.</p>

            <h2>15. Odpowiedzialność i ograniczenie roszczeń</h2>
            <p>W najszerszym zakresie dozwolonym prawem Serwis nie odpowiada za skutki używania Aplikacji w sporach rodzinnych/prawnych, decyzje Użytkowników i szkody pośrednie/utracone korzyści. Łączna odpowiedzialność Serwisu ograniczona do równowartości 3 ostatnich miesięcznych opłat Użytkownika (a w planie Free – do 100 zł), z wyjątkiem odpowiedzialności, której wyłączyć nie można.</p>

            <h2>16. Rezygnacja, odstąpienie, reklamacje i usunięcie danych</h2>
            <p>
              Użytkownik może w każdej chwili zakończyć korzystanie i żądać usunięcia danych zgodnie z Polityką Prywatności.
              W przypadku usług świadczonych w modelu subskrypcyjnym i uruchamianych niezwłocznie po płatności, Użytkownik
              wyraża zgodę na rozpoczęcie świadczenia usługi przed upływem terminu na odstąpienie i przyjmuje do wiadomości,
              że po pełnym rozpoczęciu świadczenia traci prawo odstąpienia od umowy zgodnie z art. 38 ustawy o prawach konsumenta.
            </p>
            <ul>
              <li>Odstąpienie: możliwe, jeśli świadczenie nie rozpoczęło się w pełni i Użytkownik nie wyraził zgody na jego rozpoczęcie przed upływem terminu – skontaktuj się: kontakt@2domy.pl.</li>
              <li>Reklamacje: złóż mailowo na kontakt@2domy.pl z opisem problemu, danymi konta oraz dowodem płatności; rozpatrzymy niezwłocznie, nie później niż 14 dni.</li>
              <li>Zwroty: w przypadku uznanej reklamacji zwrot następuje tą samą metodą płatności, o ile to możliwe.</li>
            </ul>

            <h2>17. Dane po zakończeniu umowy</h2>
            <p>Po zakończeniu świadczenia usług dane konta podlegają usunięciu zgodnie z Polityką Prywatności i przepisami prawa. Dane Rodzinne: eksport na żądanie; możliwa archiwizacja ograniczona czasowo przed usunięciem.</p>

            <h2>18. Zmiany Regulaminu</h2>
            <p>Zastrzegamy prawo do zmian Regulaminu. O istotnych zmianach poinformujemy (np. e‑mail, banner). Dalsze korzystanie po dacie wejścia w życie oznacza akceptację.</p>

            <h2>19. Prawo właściwe i spory</h2>
            <p>Prawo polskie. Dla konsumentów: przysługują uprawnienia z ustawy o prawach konsumenta; możliwe pozasądowe metody rozwiązywania sporów. Dla przedsiębiorców – sąd właściwy miejscowo dla siedziby Administratora.</p>

            <h2>20. Kontakt</h2>
            <p>E‑mail: kontakt@2domy.pl<br />Adres korespondencyjny: ul. Kaszubska 6/21, 83-110 Tczew</p>

            <h2>Załącznik A – Specyfikacja planów</h2>
            <div className="mt-2 space-y-2">
              <div>
                <div className="font-semibold">Basic (0 zł)</div>
                <ul className="list-disc ml-5 text-slate-700">
                  <li>1 dziecko</li>
                  <li>2 rodziców</li>
                  <li>mini historia: 10 ostatnich wpisów</li>
                </ul>
              </div>
              <div>
                <div className="font-semibold">Pro</div>
                <ul className="list-disc ml-5 text-slate-700">
                  <li>do 2 dzieci</li>
                  <li>2 rodziców + 1 obserwator</li>
                  <li>wydarzenia, notatki, koszty</li>
                  <li>raporty (kosztów, opieki)</li>
                  <li>historia 30 dni</li>
                  <li>bez reklam</li>
                </ul>
              </div>
              <div>
                <div className="font-semibold">Max</div>
                <ul className="list-disc ml-5 text-slate-700">
                  <li>do 5 dzieci</li>
                  <li>2 rodziców + 3 obserwatorów</li>
                  <li>wydarzenia, notatki, koszty</li>
                  <li>raporty (kosztów, opieki)</li>
                  <li>historia 180 dni</li>
                  <li>bez reklam</li>
                </ul>
              </div>
            </div>

            <h2>Załącznik B – Dane i podmioty przetwarzające</h2>
            <ul>
              <li>Hosting i CDN: Vercel (edge/hosting statyczny).</li>
              <li>Baza danych i uwierzytelnianie: Supabase (UE, region eu‑central‑1).</li>
              <li>Wysyłka e‑mail: Resend.</li>
              <li>Zgody ciasteczek/Consent Mode: Własne rozwiązanie oparte o bibliotekę vanilla-cookieconsent (open source).</li>
              <li>Analityka: Google Analytics 4 (z maskowaniem ścieżek wrażliwych i Consent Mode).</li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Terms


